import authAction from "./actions";

const initState = {
  isLogin: localStorage.getItem("isLogin")
    ? localStorage.getItem("isLogin") === "true"
    : false,
  accessToken: localStorage.getItem("accessToken"),
  adminType: localStorage.getItem("adminType") || null,
  storesId: null,
  storeName: null,
  storeLogo: null,
  primaryColor: localStorage.getItem("primaryColor") || null,
  secondaryColor: localStorage.getItem("secondaryColor") || null,
  sidebarColor: localStorage.getItem("sidebarColor") || null,
  topbarColor: localStorage.getItem("topbarColor") || null,
  menuHighlightColor: localStorage.getItem("menuHighlightColor") || null,
  menuTextColor: localStorage.getItem("menuTextColor") || null,
  accentColor: localStorage.getItem("accentColor") || null
};

export default function rootReducer(state = initState, action) {
  switch (action.type) {
    case authAction.LOGIN:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: action.accessToken,
        adminType: action.adminType,
        storesId: action.storesId,
        storeName: action.storeName,
        storeLogo: action.storeLogo,
        primaryColor: action.primaryColor,
        secondaryColor: action.secondaryColor,
        sidebarColor: action.sidebarColor,
        topbarColor: action.topbarColor,
        menuHighlightColor: action.menuHighlightColor,
        menuTextColor: action.menuTextColor,
        accentColor: action.accentColor
      };
    case authAction.LOGOUT:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: null,
        adminType: null,
        storesId: null,
        storeName: null,
        storeLogo: null,
        primaryColor: null,
        secondaryColor: null,
        sidebarColor: null,
        topbarColor: null,
        menuHighlightColor: null,
        menuTextColor: null,
        accentColor: null
      };
    default:
      return state;
  }
}
